
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13 14h-3a1 1 0 011-1h2v-3h1v4h-1zm1-11v3a1 1 0 01-1-1V3h-3V2h4v1zM2 13v-3a1 1 0 011 1v2h3v1H2v-1zM3 2h3a1 1 0 01-1 1H3v3H2V2h1z"}})])
          )
        }
      }
    